/**
 * URL-safe slug from a human-readable string.
 * Handles French diacritics and non-ASCII by NFD normalization.
 */
export function slugify(input) {
  if (!input) return "";
  return String(input)
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}
